export class NotificationPolicyConfigEmail {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationPolicyConfigEmail.attributeTypeMap;
    }
    constructor() {
    }
}
